import React from 'react';
import { Box } from 'braid-design-system';

import { Tags } from '../../../../types';

function AppReadyIdentifier() {
  return <Box data-cy={Tags.Data.AppReadyIdentifier} style={{ height: 1 }} />;
}

export default AppReadyIdentifier;
